/**
 * Recipe Manager Page
 * 
 * Professional chef-focused recipe management interface at /manager
 * Features:
 * - Recipe scaling with custom serving input for events/catering
 * - Duplicate and delete recipes
 * - Search and filter by cuisine/difficulty
 * - Table view with quick actions
 * - Dashboard stats
 * 
 * Route: /manager (unlisted, requires authentication)
 */

import RecipeManagerPageContainer from './RecipeManagerPage.container';

export function RecipeManagerPage() {
  return <RecipeManagerPageContainer />;
}

export default RecipeManagerPage;
